import $ from "jquery";
import App from "../src/App";
import Swiper from "swiper";
import "swiper/scss";

import "../components/slide-three-images";
import "../components/explore";
import gsap from "gsap";
import { Navigation } from "swiper/modules";

const yachtSlider = new Swiper(".js-yacht-slider-mobile", {
  modules: [Navigation],
  slidesPerView: 1,
  navigation: {
    nextEl: ".js-swiper-next",
    prevEl: ".js-swiper-prev",
  },
});
